import { actionNameGenerator } from '../../../../utils/commonUtil';

const domainPrefix = 'co';
const coActions = actionNameGenerator(domainPrefix);

export const dashboardDataFetchType = coActions('dashboardDataFetch');

export const fetchLazyDataType = coActions('fetchLazyData');

export const storeChartDataType = coActions('storeChartData');

export const disableShowType = coActions('disableShow');

export const resetDataGrantType = coActions('resetDataGrant');

export const pendingContributionLoaderType = coActions('pendingContributionLoader');

export const pendingContributionSuccessType = coActions(
  'pendingContributionSuccess'
);

export const pendingContributionsFailedType = coActions(
  'pendingContributionsFailed'
);

export const completedContributionsLoaderType = coActions(
  'completedContributionsLoader'
);

export const completedContributionsSuccessType = coActions(
  'completedContributionsSuccess'
);

export const completedContributionsFailedType = coActions(
  'completedContributionsFailed'
);

export const taxDataSuccessType = coActions('taxDataSuccess');

export const taxDataFailedType = coActions('taxDataFailed');

export const lazyLoadDataLoaderType = coActions('lazyLoadDataLoader');

export const lazyLoadPendingDataSuccessType = coActions(
  'lazyLoadPendingDataSuccess'
);

export const lazyLoadDataFailedType = coActions('lazyLoadDataFailed');

export const lazyLoadCompletedDataSuccessType = coActions(
  'lazyLoadCompletedDataSuccess'
);

export const contributionsDashboardDataLoadingType = coActions(
  'contributionsDashboardDataLoading'
);

export const contributionsDashboardDataSuccessType = coActions(
  'contributionsDashboardDataSuccess'
);

export const allContributionsDashboardDataLoadingType = coActions(
  'allContributionsDashboardDataLoading'
);

export const allContributionsDashboardDataSuccessType = coActions(
  'allContributionsDashboardDataSuccess'
);

export const allContributionsDashboardDataFailedType = coActions(
  'allContributionsDashboardDataFailed'
);

export const contributionsDashboardDataFailedType = coActions(
  'contributionsDashboardDataFailed'
);

export const valueYourContributionsLoadingType = coActions(
  'valueYourContributionsLoading'
);

export const valueYourContributionsSuccessType = coActions(
  'valueYourContributionsSuccess'
);

export const valueYourContributionsFailedType = coActions(
  'valueYourContributionsFailed'
);

export const accountDataFetchLoadingType = coActions(
  'accountDataFetchLoading'
);

export const accountDataSuccessType = coActions('accountDataSuccess');

export const accountDataFailureType = coActions('accountDataFailure');

export const ytdDataFetchLoadingType = coActions('ytdDataFetchLoading');

export const ytdDataFetchSuccessType = coActions('ytdDataFetchSuccess');

export const ytdDataFetchFailedType = coActions('ytdDataFetchFailed');

export const resetDataType = coActions('resetData');

export const storeChartDataLoadingType = coActions(
  'storeChartDataLoading'
);

export const storeChartDataSuccessType = coActions(
  'storeChartDataSuccess'
);

export const storeChartDataFailedType = coActions('storeChartDataFailed');

export const establishedDataSuccessType = coActions(
  'establishedDataSuccess'
);

export const taxReciptsLoaderType = coActions('taxReciptsLoader');
